<script lang="ts">
	import { frequentlyAskedQuestionsPathMap } from "../../../../core/schema/paths/frequentlyAskedQuestionsPathMap.js";
	import { nbspify } from "../../../../core/utils/nbspify.js";
	import { formatPrice } from "../../../../core/utils/formatPrice.js";
	import Link from "../Link.svelte";
	import StaticPicture from "../Picture/StaticPicture.svelte";
	import { getGlobalSettings } from "../../getGlobalSettings.js";

	export let name: string;
	export let image: string;
	export let price: number | undefined;
	export let minimalPrice: number | undefined;
	export let minimalPriceIsFinal = false;

	const { TENANT_LOCALE } = getGlobalSettings();
</script>

<div class="mb-7 mt-10 flex items-center gap-2">
	<StaticPicture {image} alt={name} width={32} height={32} class="aspect-square w-8"></StaticPicture>
	<div
		class="group/tooltip relative pr-4 text-xs leading-[1.2] transition-all duration-200 after:pointer-events-none after:absolute after:-left-12 after:top-full after:h-4 after:w-full after:min-w-[18rem] after:content-[''] hover:after:pointer-events-auto sm:text-base"
	>
		<span class="text-md font-semibold">{name}</span>
		<span
			class="bg-grey-200 absolute right-0 top-0 ml-0.5 grid aspect-square h-3 place-items-center rounded-full text-[9px] font-bold"
		>
			?
		</span>

		<div
			role="none"
			class="border-1 border-secondary-250 bg-secondary-100 after:border-b-secondary-100 before:border-b-secondary-250 absolute -left-10 top-full z-50 mt-3 hidden min-w-[15rem] cursor-default rounded-lg px-5 pb-4 pt-[1.375rem] text-xs before:absolute before:bottom-full before:left-3 before:border-b-[calc(.75rem+1.5px)] before:border-l-[calc(.45rem+1.5px)] before:border-r-[calc(.45rem+1.5px)] before:border-transparent before:content-[''] after:absolute after:bottom-full after:left-[calc(.75rem+1px)] after:border-b-[.75rem] after:border-l-[.45rem] after:border-r-[.45rem] after:border-transparent after:content-[''] group-hover/tooltip:flex sm:-left-12 sm:mt-[.875rem] sm:min-w-[18rem] sm:before:border-b-[calc(.75rem+1px)] sm:before:border-l-[calc(.45rem+1px)] sm:before:border-r-[calc(.45rem+1px)]"
			on:click={(event) => {
				if (!(event.target instanceof HTMLAnchorElement)) {
					event.preventDefault();
				}
			}}
		>
			<div class="flex flex-col gap-[.875rem] !font-normal">
				<slot />
				<p>
					Více informací v sekci
					<Link href={frequentlyAskedQuestionsPathMap[TENANT_LOCALE]}>časté dotazy</Link>.
				</p>
			</div>
		</div>
	</div>
	<span class="flex flex-1 justify-end text-xs font-semibold transition-all duration-200 sm:text-base">
		{#if minimalPrice !== undefined && price === 0 && !minimalPriceIsFinal}
			od&nbsp;{nbspify(formatPrice(minimalPrice, TENANT_LOCALE, false))}
		{:else if minimalPriceIsFinal && minimalPrice !== undefined && price === 0}
			+&nbsp;{nbspify(formatPrice(minimalPrice, TENANT_LOCALE, false))}
		{:else if price !== undefined}
			+&nbsp;{nbspify(formatPrice(price, TENANT_LOCALE, false))}
		{/if}
	</span>
</div>
